








import Vue from 'vue'
import Component from 'vue-class-component'

import DigitalCurrency14FrequentlyAskedQuestionsList from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-14-frequently-asked-questions-list.vue'
import App2ProjectReadme from '../../../../html-components-type-1-basic/basic-type-1-app/app-2-project-readme.vue'
import App3PleaseDonate from '../../../../html-components-type-1-basic/basic-type-1-app/app-3-please-donate.vue'


@Component({
  components: {
    DigitalCurrency14FrequentlyAskedQuestionsList,
    App2ProjectReadme,
    App3PleaseDonate
  }
})
class AboutHelperComponents3ResourceList extends Vue {

}

export default AboutHelperComponents3ResourceList

